import { Controller } from 'react-hook-form';

import FormField from 'component/FormField';

export default function InputAddress({ form }) {
  const { control, formState } = form;
  const { errors } = formState;
  return (
    <>
      <Controller
        name="address1"
        control={control}
        render={({ field }) => (
          <FormField
            name="address1"
            label="ที่อยู่สถานประกอบการ*"
            placeholder="ที่อยู่*"
            size="large"
            error={!!errors?.address1}
            dense
            {...field}
          />
        )}
      />
    </>
  );
}
